module.exports = __webpack_public_path__ + "static/media/desalitech.47a7538c.png";